module.exports = {
  urlList:{
    queryUrl:'//webadmin.wwfchina.org',
    imgUrl:'//webadmin.wwfchina.org/storage/',
    goUrl:'//webadmin.wwfchina.org/storage',
    isShowWeb:true
  }
  
  // urlList:{
  //   queryUrl:'',
  //   imgUrl:'//webadmin.wwfchina.org/storage/',
  //   goUrl:'/storage',
  //   isShowWeb:true
  // }

  // urlList:{
  //   queryUrl:'//wwfadmin.tcdinfo.com',
  //   imgUrl:'//wwfadmin.tcdinfo.com/storage/',
  //   goUrl:'//wwfadmin.tcdinfo.com/storage',
  //   isShowWeb:true
  // }
}